import '@common/assets/styles/theme.css';
// import { AppProvider } from "@shopify/polaris";
// import "@shopify/polaris/build/esm/styles.css";
// import enTranslations from "@shopify/polaris/locales/en.json";
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './main.css';
import { startWebsiteRum } from './lib/rum';
import { initSentry } from './lib/sentry';
import { router } from './router';

const redirectLegacyTopupReturnPath = () => {
    if (typeof window === 'undefined') {
        return;
    }

    const { pathname, search, hash } = window.location;
    if (pathname !== '/usage') {
        return;
    }

    const searchParams = new URLSearchParams(search);
    const isTopupReturn =
        searchParams.get('payment_modal') === 'usage'
        || Boolean(searchParams.get('topup_result'));
    if (!isTopupReturn) {
        return;
    }

    window.history.replaceState({}, '', `/admin/usage${search}${hash}`);
};

initSentry();
startWebsiteRum();
redirectLegacyTopupReturnPath();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <Sentry.ErrorBoundary fallback={<div role="alert">Something went wrong.</div>}>
        <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
)
